import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import BusinessPlan from "@/pages/BusinessPlan";
import DOLProposal from "@/pages/DOLProposal";
import Beneficiaries from "@/pages/Beneficiaries";
import Vouchers from "@/pages/Vouchers";
import Partners from "@/pages/Partners";
import Budget from "@/pages/Budget";
import Grants from "@/pages/Grants";
import Outreach from "@/pages/Outreach";
import GetHelp from "@/pages/GetHelp";
import Applications from "@/pages/Applications";
import VoucherVerify from "@/pages/VoucherVerify";
import Login from "@/pages/Login";
import Users from "@/pages/Users";
import SubmitReferral from "@/pages/SubmitReferral";
import MyReferrals from "@/pages/MyReferrals";
import Donate from "@/pages/Donate";
import Donations from "@/pages/Donations";
import Contacts from "@/pages/Contacts";
import { DonateSuccess, DonateCancel } from "@/pages/DonateStatus";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const STAFF = ["admin", "staff"];
const ADMIN = ["admin"];
const REFERRAL = ["referral_partner"];

function App() {
  useEffect(() => {
    axios.post(`${API}/seed`).catch(() => {});
  }, []);

  return (
    <div className="App min-h-screen bg-background">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/business-plan" element={<BusinessPlan />} />
            <Route path="/dol-proposal" element={<DOLProposal />} />
            <Route path="/verify/:code" element={<VoucherVerify />} />
            <Route path="/get-help" element={<GetHelp />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donate/success" element={<DonateSuccess />} />
            <Route path="/donate/cancel" element={<DonateCancel />} />
            <Route path="/login" element={<Login />} />

            {/* Authenticated portal */}
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<ProtectedRoute roles={STAFF}><Dashboard /></ProtectedRoute>} />
              <Route path="/beneficiaries" element={<ProtectedRoute roles={STAFF}><Beneficiaries /></ProtectedRoute>} />
              <Route path="/applications" element={<ProtectedRoute roles={STAFF}><Applications /></ProtectedRoute>} />
              <Route path="/vouchers" element={<ProtectedRoute roles={STAFF}><Vouchers /></ProtectedRoute>} />
              <Route path="/partners" element={<ProtectedRoute roles={STAFF}><Partners /></ProtectedRoute>} />
              <Route path="/budget" element={<ProtectedRoute roles={ADMIN}><Budget /></ProtectedRoute>} />
              <Route path="/grants" element={<ProtectedRoute roles={ADMIN}><Grants /></ProtectedRoute>} />
              <Route path="/donations" element={<ProtectedRoute roles={ADMIN}><Donations /></ProtectedRoute>} />
              <Route path="/contacts" element={<ProtectedRoute roles={ADMIN}><Contacts /></ProtectedRoute>} />
              <Route path="/outreach" element={<ProtectedRoute roles={STAFF}><Outreach /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute roles={ADMIN}><Users /></ProtectedRoute>} />
              <Route path="/referrals/new" element={<ProtectedRoute roles={REFERRAL}><SubmitReferral /></ProtectedRoute>} />
              <Route path="/referrals/mine" element={<ProtectedRoute roles={REFERRAL}><MyReferrals /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
